import { render, staticRenderFns } from "./TenantApp.vue?vue&type=template&id=9dac9efa&scoped=true"
import script from "./TenantApp.vue?vue&type=script&lang=js"
export * from "./TenantApp.vue?vue&type=script&lang=js"
import style0 from "./TenantApp.vue?vue&type=style&index=0&id=9dac9efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dac9efa",
  null
  
)

export default component.exports